import Gallery from "react-photo-gallery";
//import { Card } from "react-bootstrap";
import { useCallback, useState, useEffect } from "react";
import "./PascuaYaquiRender.css";
import pascuaYaqui1 from "../../../images/pascuaYaquiImages/pascuaYaqui1.jpg";
import pascuaYaqui2 from "../../../images/pascuaYaquiImages/pascuaYaqui2.jpg";
import pascuaYaqui3 from "../../../images/pascuaYaquiImages/pascuaYaqui3.jpg";
import pascuaYaqui4 from "../../../images/pascuaYaquiImages/pascuaYaqui4.jpg";
import pascuaYaqui5 from "../../../images/pascuaYaquiImages/pascuaYaqui5.jpg";
import pascuaYaqui6 from "../../../images/pascuaYaquiImages/pascuaYaqui6.jpg";
import pascuaYaqui7 from "../../../images/pascuaYaquiImages/pascuaYaqui7.jpg";
import pascuaYaqui8 from "../../../images/pascuaYaquiImages/pascuaYaqui8.jpg";
import pascuaYaqui9 from "../../../images/pascuaYaquiImages/pascuaYaqui9.jpg";
import pascuaYaqui10 from "../../../images/pascuaYaquiImages/pascuaYaqui10.jpg";
import pascuaYaqui11 from "../../../images/pascuaYaquiImages/pascuaYaqui11.jpg";

export default function PascuaYaquiRender() {

  const PascuaYaquiPics = [
    {
      src: pascuaYaqui1,
      caption: "Map of Yaqui Pueblos in Sonora, Mexico, and Arizona, U.S.A. Map drawn by Arizona State Museum/University of Arizona in consultation with the Pascua Yaqui Tribe Department of Language and Culture, 2019"
    },
    /*{
      src: pascuaYaqui2,
      caption: "test caption"
    },
    {
      src: pascuaYaqui3,
      caption: "test caption"
    },
    {
      src: pascuaYaqui4,
      caption: "test caption"
    },*/
    {
      src: pascuaYaqui5,
      caption: "Luis Martinez making adobes for a man in north part of Tucson, AZ, photographer unknown, 5/25/1937 ASM 2000-175-1101"
    },
    {
      src: pascuaYaqui6,
      caption: "Dipping water from the acequia. Casillas house in background. Maria Casillas (?) with boy and girl, David J. Jones, photographer, 1937 2000-175-1376"
    },
    {
      src: pascuaYaqui7,
      caption: "The horno, an outside bake oven, at Ochoa's. Juan and Ignacio Ochoa standing by the oven. Old Pascua, Tucson, AZ. Photographer unknown, 1937 ASM-2000-175-1037"
    },
    {
      src: pascuaYaqui8,
      caption: "Yaquis making adobe bricks for new homes, New Pascua, Arizona, Helga Teiwes, photographer 1966-1967 ASM 16901"
    },
    {
      src: pascuaYaqui9,
      caption: "Yaquis making adobe bricks for new homes, New Pascua, Arizona, Helga Teiwes, photographer 1966-1967 ASM 16903"
    },
    /*{
      src: pascuaYaqui10,
      caption: "test caption"
    },
    {
      src: pascuaYaqui11,
      caption: "test caption"
    },*/
  ];

  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="https://matomo.aws.coh.arizona.edu/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '64']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();

  function GalleryComponent({ images }) {

    const [isLoading, setIsLoading] = useState(true);
    const [photos, setPhotos] = useState([]);

    const cont = {
      overflow: "hidden",
      position: "relative",
    };

    const getImageDimensions = async (file) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = file;
        img.onload = () => {
          const { naturalWidth: width, naturalHeight: height } = img;
          resolve({ width, height });
        };
        img.onerror = reject;
      });
    };
    
    useEffect(() => {
      console.log(images)
      Promise.all(
        images.map((image, i) =>
          getImageDimensions(image.src, i).then((dims) => ({ ...image, ...dims }))
        )
      ).then((photos) => {
        setPhotos(photos);
        setIsLoading(false); // Set loading to false after images have been loaded
      }).catch((error) => {
        console.error(error);
      });
    }, []);

    const GalleryImage = ({ photo, margin, direction, top, left, index }) => {

      console.log(margin)
  
      const imgStyle = {
        maxWidth: "14.6vw",
        height: "auto",
      };

      if (direction === "column") {
        cont.position = "absolute";
        cont.left = left;
        cont.top = top;
      }
  
      return (
        <div
          style={{
            margin,
            width: photo.width,
            maxWidth: "14.6vw",
            height: "auto",
            objectFit: "contain",
            border: "0.01px solid rgb(200,200,200)",
            backgroundColor: "rgb(32, 32, 32)",
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
            // width: "24%",
            ...cont,
          }}>
          {/* <img alt={photo.title} className="image" style={{ width: "100%"}} {...photo} /> */}
          <img
            alt={photo.title}
            style={imgStyle}
            {...photo}
            src={photo.src}
          />
          <div className="image-caption">
            {photo.caption.split("\n").map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </div>
        </div>
      );
    };
  
    const imageRenderer = useCallback(
      ({ index, left, top, key, photo }) => (
        <GalleryImage
          key={index}
          margin={"1.6px"}
          index={index}
          photo={photo}
          left={left}
          top={top}
        />
      ),
      []
    );

    return (
      <div className="image-gallery">
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1rem",
            }}>
          </div>
        ) : (
          <>
            <Gallery photos={photos} renderImage={imageRenderer} />
          </>
        )}
      </div>
    );
  }

  return <GalleryComponent images={PascuaYaquiPics}/>

}